import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_COLLECTION_RECORD } from '../actions';

import {
  createCollectionRecordSuccess,
  createCollectionRecordError
} from './actions';

const CREATE_COLLECTION_RECORD_ERROR = "Collection record creation fails.";

const createCollectionRecordAsync = async (newRecord, id) => {
  let dataReturned;
  try {
    dataReturned = id > 0 ? await centralApiAxios.put("collections/id=" + id, newRecord) : await centralApiAxios.post("collections", newRecord);
    if (dataReturned.data && dataReturned.data.collection_id > 0) {
      return {
        collection: dataReturned.data,
        message: null,
      };
    }
    return { message: CREATE_COLLECTION_RECORD_ERROR };
  } catch (error) {
    return {
      message: CREATE_COLLECTION_RECORD_ERROR,
    };
  }
};

function* createCollectionRecord({ payload }) {
  try {
    const resultReturned = yield call(createCollectionRecordAsync, payload.newRecord, payload.id);
    if (!resultReturned.message) {
      yield put(createCollectionRecordSuccess(resultReturned.collection));
      window.location.reload();
    } else {
      yield put(createCollectionRecordError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createCollectionRecordError(CREATE_COLLECTION_RECORD_ERROR));
  }
}

export function* watchCreateCollectionItem() {
  yield takeEvery(CREATE_COLLECTION_RECORD, createCollectionRecord);
}


export default function* rootSaga() {
  yield all([
    fork(watchCreateCollectionItem)
  ]);
}
